import { sub } from 'date-fns'

/**
 * Returns a router basename by checking the hostname against the `DEPLOYMENT_URL_BASEPATH_MAP` environment variable.
 * This enables the app to run on both the `/dyson` subpath and the `/` root path.
 * @returns The router basename.
 */
export function getRouterBasename() {
  const { hostname } = window.location

  const map: Record<string, string> = JSON.parse(DEPLOYMENT_URL_BASEPATH_MAP)

  let basename = '/'

  // Update the basename if the hostname is found in the map
  Object.entries(map).forEach(([key, value]) => {
    if (hostname === key) {
      basename = value
    }
  })

  return basename
}

/**
 * Uses the `getRouterBasename()` method to determine if the router basename is not the root.
 * @returns True if the router basename is not the root.
 */
export function hasRouterBasename() {
  const basename = getRouterBasename()
  return basename !== '/'
}

/**
 * Get the date range for last n days
 * @param now
 * @param days
 * @returns date range tuple
 */
export function getDateRangeForLast(now: Date, days: number): [Date, Date] {
  const start = sub(now, { days })

  return [start, now]
}

/**
 * Get params to filter orders by created date
 * @returns query string
 */
export function getLastSixtyDaysParams(): { createdStart: Date; createdEnd: Date } {
  const [start, end] = getDateRangeForLast(new Date(), 60)

  return {
    createdStart: start,
    createdEnd: end,
  }
}
